// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"9ZAis":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultItems", ()=>defaultItems);
///- end collapse -///
parcelHelpers.export(exports, "PokemonListBox", ()=>PokemonListBox);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
var _reactAriaComponents = require("react-aria-components");
'use client';
let defaultItems = [
    {
        id: 1,
        name: 'Charizard',
        type: 'Fire, Flying',
        level: 67
    },
    {
        id: 2,
        name: 'Blastoise',
        type: 'Water',
        level: 56
    },
    {
        id: 3,
        name: 'Venusaur',
        type: 'Grass, Poison',
        level: 83
    },
    {
        id: 4,
        name: 'Pikachu',
        type: 'Electric',
        level: 100
    }
];
function PokemonListBox(props) {
    let { items = defaultItems, dragAndDropHooks } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBox), {
        "aria-label": "Pokemon list",
        selectionMode: "multiple",
        items: items,
        renderEmptyState: ()=>'Drop items here',
        dragAndDropHooks: dragAndDropHooks,
        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBoxItem), {
                textValue: item.name,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "label",
                        children: item.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "description",
                        children: item.type
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","react-aria-components":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kNiGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBox", ()=>ListBox);
parcelHelpers.export(exports, "ListBoxItem", ()=>ListBoxItem);
parcelHelpers.export(exports, "ListBoxSection", ()=>ListBoxSection);
parcelHelpers.export(exports, "ListBoxLoadMoreItem", ()=>ListBoxLoadMoreItem);
parcelHelpers.export(exports, "DropdownListBox", ()=>DropdownListBox);
parcelHelpers.export(exports, "DropdownItem", ()=>DropdownItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _lucideReact = require("lucide-react");
var _content = require("./Content");
var _progressCircle = require("./ProgressCircle");
var _listBoxCss = require("./ListBox.css");
'use client';
function ListBox({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
        ...props,
        children: children
    });
}
function ListBoxItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        textValue: textValue,
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "label",
                children: children
            }) : children)
    });
}
function ListBoxSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxSection), {
        ...props
    });
}
function ListBoxLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading more..."
        })
    });
}
function DropdownListBox(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
        ...props,
        className: "dropdown-listbox"
    });
}
function DropdownItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListBoxItem, {
        ...props,
        textValue: textValue,
        className: "dropdown-item",
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {}),
                    typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                        slot: "label",
                        children: children
                    }) : children
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxLoadMoreItem","dNdIK"],["ListBoxSection","dNdIK"]],"lucide-react":[["Check","9PYFQ","default"]],"./Content":"jYtLe","./ProgressCircle":"c08Ay","./ListBox.css":"bDSGu","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9PYFQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Check);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const Check = (0, _createLucideIconJsDefault.default)("check", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jYtLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>Heading);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _contentCss = require("./Content.css");
function Heading(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...props
    });
}
function Text(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Heading","2f4nH"],["Text","jt9fm"]],"./Content.css":"kvyv3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvyv3":[function() {},{}],"c08Ay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressCircle", ()=>ProgressCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
'use client';
function ProgressCircle(props) {
    // SVG strokes are centered, so subtract half the stroke width from the radius to create an inner stroke.
    let strokeWidth = 4;
    let radius = `calc(50% - ${strokeWidth / 2}px)`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ProgressBar), {
        ...props,
        style: (0, _reactAriaComponents.composeRenderProps)(props.style, (style)=>({
                ...style,
                width: props.size || 16,
                height: props.size || 16
            })),
        children: ({ percentage, isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    fill: "none",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 32 32",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-pressed)",
                            strokeWidth: strokeWidth
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-background)",
                            strokeWidth: strokeWidth,
                            // Normalize the path length to 100 so we can easily set stroke-dashoffset to a percentage.
                            pathLength: "100",
                            // Add extra gap between dashes so 0% works in Chrome.
                            strokeDasharray: "100 200",
                            strokeDashoffset: 100 - (isIndeterminate || percentage == null ? 25 : percentage),
                            strokeLinecap: "round",
                            style: {
                                rotate: '-90deg',
                                transformOrigin: 'center center'
                            },
                            children: isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                dur: "0.75s",
                                values: "0;360",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["ProgressBar","kPGON"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bDSGu":[function() {},{}],"4kzQ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultItems", ()=>defaultItems);
///- end collapse -///
parcelHelpers.export(exports, "PokemonGridList", ()=>PokemonGridList);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
'use client';
let defaultItems = [
    {
        id: 1,
        name: 'Charizard',
        type: 'Fire, Flying',
        level: 67
    },
    {
        id: 2,
        name: 'Blastoise',
        type: 'Water',
        level: 56
    },
    {
        id: 3,
        name: 'Venusaur',
        type: 'Grass, Poison',
        level: 83
    },
    {
        id: 4,
        name: 'Pikachu',
        type: 'Electric',
        level: 100
    }
];
function PokemonGridList(props) {
    let { items = defaultItems, dragAndDropHooks } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
        "aria-label": "Pokemon list",
        selectionMode: "multiple",
        items: items,
        renderEmptyState: ()=>'Drop items here',
        dragAndDropHooks: dragAndDropHooks,
        "data-size": "small",
        style: {
            border: '1px solid var(--border-color'
        },
        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
                textValue: item.name,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: `https://img.pokemondb.net/sprites/home/normal/2x/avif/${item.name.toLowerCase()}.avif`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        children: item.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "description",
                        children: item.type
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hvGD4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridList", ()=>GridList);
parcelHelpers.export(exports, "GridListItem", ()=>GridListItem);
parcelHelpers.export(exports, "GridListLoadMoreItem", ()=>GridListLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _lucideReact = require("lucide-react");
var _progressCircle = require("./ProgressCircle");
var _gridListCss = require("./GridList.css");
'use client';
function GridList({ children, layout = 'grid', ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridList), {
        ...props,
        layout: layout,
        children: children
    });
}
function GridListItem({ children, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridListItem), {
        textValue: textValue,
        ...props,
        children: ({ selectionMode, selectionBehavior, allowsDragging })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "drag",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.GripVertical), {
                            size: 16
                        })
                    }),
                    selectionMode === 'multiple' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                        slot: "selection"
                    }),
                    children
                ]
            })
    });
}
function GridListLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridListLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading more..."
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["GridList","8bLgh"],["GridListItem","8bLgh"],["GridListLoadMoreItem","8bLgh"]],"./Checkbox":"eZZAR","lucide-react":[["GripVertical","1JqDe","default"]],"./ProgressCircle":"c08Ay","./GridList.css":"36Tst","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eZZAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkboxCss = require("./Checkbox.css");
'use client';
function Checkbox({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Checkbox), {
        ...props,
        children: ({ isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "indicator",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            viewBox: "0 0 18 18",
                            "aria-hidden": "true",
                            children: isIndeterminate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: 1,
                                y: 7.5,
                                width: 16,
                                height: 3
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                points: "2 9 7 14 16 4"
                            })
                        }, isIndeterminate ? 'indeterminate' : 'check')
                    }),
                    children
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"9jC2J","./Checkbox.css":"2wQgb","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2wQgb":[function() {},{}],"1JqDe":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>GripVertical);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "1",
            key: "1vctgf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "5",
            r: "1",
            key: "hp0tcf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "19",
            r: "1",
            key: "fkjjf6"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "1",
            key: "1tmaij"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "19",
            r: "1",
            key: "f4zoj3"
        }
    ]
];
const GripVertical = (0, _createLucideIconJsDefault.default)("grip-vertical", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"36Tst":[function() {},{}],"1oWZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
var _droppableListBox = require("./DroppableListBox");
"use client";
function DraggableListBox() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, values) {
            return values.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableListBox, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableListBox.DroppableListBox), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonListBox":"9ZAis","./DroppableListBox":"4Ffgp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Ffgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppableListBox", ()=>DroppableListBox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
'use client';
function DroppableListBox() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"./PokemonListBox":"9ZAis","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gR4JY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "droppableCollectionMap", ()=>droppableCollectionMap);
parcelHelpers.export(exports, "DIRECTORY_DRAG_TYPE", ()=>DIRECTORY_DRAG_TYPE);
parcelHelpers.export(exports, "getDroppableCollectionId", ()=>getDroppableCollectionId);
parcelHelpers.export(exports, "getDroppableCollectionRef", ()=>getDroppableCollectionRef);
parcelHelpers.export(exports, "getTypes", ()=>getTypes);
parcelHelpers.export(exports, "useDragModality", ()=>useDragModality);
parcelHelpers.export(exports, "getDragModality", ()=>getDragModality);
parcelHelpers.export(exports, "writeToDataTransfer", ()=>writeToDataTransfer);
parcelHelpers.export(exports, "DragTypes", ()=>DragTypes);
parcelHelpers.export(exports, "readFromDataTransfer", ()=>readFromDataTransfer);
/** Returns whether a drop item contains text data. */ parcelHelpers.export(exports, "isTextDropItem", ()=>isTextDropItem);
/** Returns whether a drop item is a file. */ parcelHelpers.export(exports, "isFileDropItem", ()=>isFileDropItem);
/** Returns whether a drop item is a directory. */ parcelHelpers.export(exports, "isDirectoryDropItem", ()=>isDirectoryDropItem);
parcelHelpers.export(exports, "globalDndState", ()=>globalDndState);
parcelHelpers.export(exports, "setDraggingCollectionRef", ()=>setDraggingCollectionRef);
parcelHelpers.export(exports, "setDraggingKeys", ()=>setDraggingKeys);
parcelHelpers.export(exports, "setDropCollectionRef", ()=>setDropCollectionRef);
parcelHelpers.export(exports, "clearGlobalDnDState", ()=>clearGlobalDnDState);
parcelHelpers.export(exports, "setGlobalDnDState", ()=>setGlobalDnDState);
// Util function to check if the current dragging collection ref is the same as the current targeted droppable collection ref.
// Allows a droppable ref arg in case the global drop collection ref hasn't been set
parcelHelpers.export(exports, "isInternalDropOperation", ()=>isInternalDropOperation);
parcelHelpers.export(exports, "globalDropEffect", ()=>globalDropEffect);
parcelHelpers.export(exports, "setGlobalDropEffect", ()=>setGlobalDropEffect);
parcelHelpers.export(exports, "globalAllowedDropOperations", ()=>globalAllowedDropOperations);
parcelHelpers.export(exports, "setGlobalAllowedDropOperations", ()=>setGlobalAllowedDropOperations);
var _constants = require("./constants");
var _interactions = require("@react-aria/interactions");
const droppableCollectionMap = new WeakMap();
const DIRECTORY_DRAG_TYPE = Symbol();
function getDroppableCollectionId(state) {
    let { id } = droppableCollectionMap.get(state) || {};
    if (!id) throw new Error('Droppable item outside a droppable collection');
    return id;
}
function getDroppableCollectionRef(state) {
    let { ref } = droppableCollectionMap.get(state) || {};
    if (!ref) throw new Error('Droppable item outside a droppable collection');
    return ref;
}
function getTypes(items) {
    let types = new Set();
    for (let item of items)for (let type of Object.keys(item))types.add(type);
    return types;
}
function mapModality(modality) {
    if (!modality) modality = 'virtual';
    if (modality === 'pointer') modality = 'virtual';
    if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'touch';
    return modality;
}
function useDragModality() {
    return mapModality((0, _interactions.useInteractionModality)());
}
function getDragModality() {
    return mapModality((0, _interactions.getInteractionModality)());
}
function writeToDataTransfer(dataTransfer, items) {
    // The data transfer API doesn't support more than one item of a given type at once.
    // In addition, only a small set of types are supported natively for transfer between applications.
    // We allow for both multiple items, as well as multiple representations of a single item.
    // In order to make our API work with the native API, we serialize all items to JSON and
    // store as a single native item. We only need to do this if there is more than one item
    // of the same type, or if an item has more than one representation. Otherwise the native
    // API is sufficient.
    //
    // The DataTransferItemList API also theoretically supports adding files, which would enable
    // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
    // this does not currently work in any browser, so it is not currently supported by our API.
    // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
    let groupedByType = new Map();
    let needsCustomData = false;
    let customData = [];
    for (let item of items){
        let types = Object.keys(item);
        if (types.length > 1) needsCustomData = true;
        let dataByType = {};
        for (let type of types){
            let typeItems = groupedByType.get(type);
            if (!typeItems) {
                typeItems = [];
                groupedByType.set(type, typeItems);
            } else needsCustomData = true;
            let data = item[type];
            dataByType[type] = data;
            typeItems.push(data);
        }
        customData.push(dataByType);
    }
    for (let [type, items] of groupedByType)if ((0, _constants.NATIVE_DRAG_TYPES).has(type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        let data = items.join('\n');
        dataTransfer.items.add(data, type);
    } else // Set data to the first item so we have access to the list of types.
    dataTransfer.items.add(items[0], type);
    if (needsCustomData) {
        let data = JSON.stringify(customData);
        dataTransfer.items.add(data, (0, _constants.CUSTOM_DRAG_TYPE));
    }
}
class DragTypes {
    constructor(dataTransfer){
        this.types = new Set();
        let hasFiles = false;
        for (let item of dataTransfer.items)if (item.type !== (0, _constants.CUSTOM_DRAG_TYPE)) {
            if (item.kind === 'file') hasFiles = true;
            if (item.type) this.types.add(item.type);
            else // Files with unknown types or extensions that don't map to a known mime type
            // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, _constants.GENERIC_TYPE));
        }
        // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
        // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
        // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
        this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes('Files');
    }
    has(type) {
        if (this.includesUnknownTypes || type === DIRECTORY_DRAG_TYPE && this.types.has((0, _constants.GENERIC_TYPE))) return true;
        return typeof type === 'string' && this.types.has(type);
    }
}
function readFromDataTransfer(dataTransfer) {
    let items = [];
    if (!dataTransfer) return items;
    // If our custom drag type is available, use that. This is a JSON serialized
    // representation of all items in the drag, set when there are multiple items
    // of the same type, or an individual item has multiple representations.
    let hasCustomType = false;
    if (dataTransfer.types.includes((0, _constants.CUSTOM_DRAG_TYPE))) try {
        let data = dataTransfer.getData((0, _constants.CUSTOM_DRAG_TYPE));
        let parsed = JSON.parse(data);
        for (let item of parsed)items.push({
            kind: 'text',
            types: new Set(Object.keys(item)),
            getText: (type)=>Promise.resolve(item[type])
        });
        hasCustomType = true;
    } catch  {
    // ignore
    }
    // Otherwise, map native drag items to items of a single representation.
    if (!hasCustomType) {
        let stringItems = new Map();
        for (let item of dataTransfer.items){
            if (item.kind === 'string') // The data for all formats must be read here because the data transfer gets
            // cleared out after the event handler finishes. If the item has an empty string
            // as a type, the mime type is unknown. Map to a generic mime type instead.
            stringItems.set(item.type || (0, _constants.GENERIC_TYPE), dataTransfer.getData(item.type));
            else if (item.kind === 'file') {
                // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
                // In the future, we may use getAsFileSystemHandle instead, but that's currently
                // only implemented in Chrome.
                if (typeof item.webkitGetAsEntry === 'function') {
                    let entry = item.webkitGetAsEntry();
                    // eslint-disable-next-line max-depth
                    if (!entry) continue;
                    // eslint-disable-next-line max-depth
                    if (entry.isFile) items.push(createFileItem(item.getAsFile()));
                    else if (entry.isDirectory) items.push(createDirectoryItem(entry));
                } else // Assume it's a file.
                items.push(createFileItem(item.getAsFile()));
            }
        }
        // All string items are different representations of the same item. There's no way to have
        // multiple string items at once in the current DataTransfer API.
        if (stringItems.size > 0) items.push({
            kind: 'text',
            types: new Set(stringItems.keys()),
            getText: (type)=>Promise.resolve(stringItems.get(type))
        });
    }
    return items;
}
function blobToString(blob) {
    if (typeof blob.text === 'function') return blob.text();
    // Safari doesn't have the Blob#text() method yet...
    return new Promise((resolve, reject)=>{
        let reader = new FileReader;
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(blob);
    });
}
function createFileItem(file) {
    if (!file) throw new Error('No file provided');
    return {
        kind: 'file',
        type: file.type || (0, _constants.GENERIC_TYPE),
        name: file.name,
        getText: ()=>blobToString(file),
        getFile: ()=>Promise.resolve(file)
    };
}
function createDirectoryItem(entry) {
    return {
        kind: 'directory',
        name: entry.name,
        getEntries: ()=>getEntries(entry)
    };
}
async function* getEntries(item) {
    let reader = item.createReader();
    // We must call readEntries repeatedly because there may be a limit to the
    // number of entries that are returned at once.
    let entries;
    do {
        entries = await new Promise((resolve, reject)=>{
            reader.readEntries(resolve, reject);
        });
        for (let entry of entries){
            if (entry.isFile) {
                let file = await getEntryFile(entry);
                yield createFileItem(file);
            } else if (entry.isDirectory) yield createDirectoryItem(entry);
        }
    }while (entries.length > 0);
}
function getEntryFile(entry) {
    return new Promise((resolve, reject)=>entry.file(resolve, reject));
}
function isTextDropItem(dropItem) {
    return dropItem.kind === 'text';
}
function isFileDropItem(dropItem) {
    return dropItem.kind === 'file';
}
function isDirectoryDropItem(dropItem) {
    return dropItem.kind === 'directory';
}
let globalDndState = {
    draggingKeys: new Set()
};
function setDraggingCollectionRef(ref) {
    globalDndState.draggingCollectionRef = ref;
}
function setDraggingKeys(keys) {
    globalDndState.draggingKeys = keys;
}
function setDropCollectionRef(ref) {
    globalDndState.dropCollectionRef = ref;
}
function clearGlobalDnDState() {
    globalDndState = {
        draggingKeys: new Set()
    };
}
function setGlobalDnDState(state) {
    globalDndState = state;
}
function isInternalDropOperation(ref) {
    let { draggingCollectionRef, dropCollectionRef } = globalDndState;
    return draggingCollectionRef?.current != null && draggingCollectionRef.current === (ref?.current || dropCollectionRef?.current);
}
let globalDropEffect;
function setGlobalDropEffect(dropEffect) {
    globalDropEffect = dropEffect;
}
let globalAllowedDropOperations = (0, _constants.DROP_OPERATION).none;
function setGlobalAllowedDropOperations(o) {
    globalAllowedDropOperations = o;
}

},{"./constants":"dL7d2","@react-aria/interactions":"dkfxW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dL7d2":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DROP_OPERATION", ()=>DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_ALLOWED", ()=>DROP_OPERATION_ALLOWED);
parcelHelpers.export(exports, "EFFECT_ALLOWED", ()=>EFFECT_ALLOWED);
parcelHelpers.export(exports, "DROP_EFFECT_TO_DROP_OPERATION", ()=>DROP_EFFECT_TO_DROP_OPERATION);
parcelHelpers.export(exports, "DROP_OPERATION_TO_DROP_EFFECT", ()=>DROP_OPERATION_TO_DROP_EFFECT);
parcelHelpers.export(exports, "NATIVE_DRAG_TYPES", ()=>NATIVE_DRAG_TYPES);
parcelHelpers.export(exports, "CUSTOM_DRAG_TYPE", ()=>CUSTOM_DRAG_TYPE);
parcelHelpers.export(exports, "GENERIC_TYPE", ()=>GENERIC_TYPE);
var DROP_OPERATION = /*#__PURE__*/ function(DROP_OPERATION) {
    DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
    DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
    DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
    DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
    DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
    DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
    return DROP_OPERATION;
}({});
const DROP_OPERATION_ALLOWED = {
    ...DROP_OPERATION,
    copyMove: 3,
    copyLink: 6,
    linkMove: 5,
    all: 7,
    uninitialized: 7
};
const EFFECT_ALLOWED = invert(DROP_OPERATION_ALLOWED);
EFFECT_ALLOWED[7] = 'all'; // ensure we don't map to 'uninitialized'.
const DROP_EFFECT_TO_DROP_OPERATION = {
    none: 'cancel',
    link: 'link',
    copy: 'copy',
    move: 'move'
};
const DROP_OPERATION_TO_DROP_EFFECT = invert(DROP_EFFECT_TO_DROP_OPERATION);
function invert(object) {
    let res = {};
    for(let key in object)res[object[key]] = key;
    return res;
}
const NATIVE_DRAG_TYPES = new Set([
    'text/plain',
    'text/uri-list',
    'text/html'
]);
const CUSTOM_DRAG_TYPE = 'application/vnd.react-aria.items+json';
const GENERIC_TYPE = 'application/octet-stream';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"boUte":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
var _droppableGridList = require("./DroppableGridList");
"use client";
function DraggableGridList() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, values) {
            return values.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableGridList, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableGridList.DroppableGridList), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonGridList":"4kzQ7","./DroppableGridList":"82HX7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"82HX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppableGridList", ()=>DroppableGridList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
'use client';
function DroppableGridList() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"./PokemonGridList":"4kzQ7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8CzPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTree = require("./PokemonTree");
var _droppableTree = require("./DroppableTree");
"use client";
function DraggableTree() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, values) {
            return values.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTree, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableTree.DroppableTree), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTree":"lbTeS","./DroppableTree":"1ABDu","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lbTeS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultItems", ()=>defaultItems);
///- end collapse -///
parcelHelpers.export(exports, "PokemonTree", ()=>PokemonTree);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
var _reactAriaComponents = require("react-aria-components");
'use client';
let defaultItems = [
    {
        id: 1,
        name: 'Bulbasaur',
        type: 'Grass',
        level: 14,
        children: [
            {
                id: 2,
                name: 'Ivysaur',
                type: 'Grass',
                level: 30,
                children: [
                    {
                        id: 3,
                        name: 'Venusaur',
                        type: 'Grass',
                        level: 83
                    }
                ]
            }
        ]
    },
    {
        id: 4,
        name: 'Charmander',
        type: 'Fire',
        level: 16,
        children: [
            {
                id: 5,
                name: 'Charmeleon',
                type: 'Fire',
                level: 32,
                children: [
                    {
                        id: 6,
                        name: 'Charizard',
                        type: 'Fire, Flying',
                        level: 67
                    }
                ]
            }
        ]
    },
    {
        id: 7,
        name: 'Squirtle',
        type: 'Water',
        level: 8,
        children: [
            {
                id: 8,
                name: 'Wartortle',
                type: 'Water',
                level: 34,
                children: [
                    {
                        id: 9,
                        name: 'Blastoise',
                        type: 'Water',
                        level: 56
                    }
                ]
            }
        ]
    },
    {
        id: 10,
        name: 'Pichu',
        type: 'Electric',
        level: 45,
        children: [
            {
                id: 11,
                name: 'Pikachu',
                type: 'Electric',
                level: 85,
                children: [
                    {
                        id: 12,
                        name: 'Raichu',
                        type: 'Electric',
                        level: 100
                    }
                ]
            }
        ]
    }
];
function PokemonTree(props) {
    let { items = defaultItems, dragAndDropHooks } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.Tree), {
        "aria-label": "Pokemon tree",
        selectionMode: "multiple",
        items: items,
        renderEmptyState: ()=>'Drop items here',
        dragAndDropHooks: dragAndDropHooks,
        children: function renderItem(item) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: item.name
                        }),
                        " \u2013 ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: item.type
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                    items: item.children,
                    children: renderItem
                })
            });
        }
    });
}

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","react-aria-components":"2Jd0Q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ifc8k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tree", ()=>Tree);
parcelHelpers.export(exports, "TreeItemContent", ()=>TreeItemContent);
parcelHelpers.export(exports, "TreeItem", ()=>TreeItem);
parcelHelpers.export(exports, "TreeLoadMoreItem", ()=>TreeLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _lucideReact = require("lucide-react");
var _checkbox = require("./Checkbox");
var _progressCircle = require("./ProgressCircle");
var _treeCss = require("./Tree.css");
'use client';
function Tree(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tree), {
        ...props
    });
}
function TreeItemContent(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TreeItemContent), {
        children: ({ selectionBehavior, selectionMode, allowsDragging })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "drag",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.GripVertical), {
                            size: 16
                        })
                    }),
                    selectionBehavior === 'toggle' && selectionMode !== 'none' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                        slot: "selection"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "chevron",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {})
                    }),
                    props.children
                ]
            })
    });
}
function TreeItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TreeItem), {
        textValue: props.title,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TreeItemContent, {
                children: props.title
            }),
            props.children
        ]
    });
}
function TreeLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TreeLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading more..."
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Tree","kwlwT"],["TreeItem","kwlwT"],["TreeItemContent","kwlwT"],["TreeLoadMoreItem","kwlwT"]],"lucide-react":[["ChevronRight","elAlB","default"],["GripVertical","1JqDe","default"]],"./Checkbox":"eZZAR","./ProgressCircle":"c08Ay","./Tree.css":"3VY5L","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAlB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3VY5L":[function() {},{}],"1ABDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppableTree", ()=>DroppableTree);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTree = require("./PokemonTree");
'use client';
function DroppableTree() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTree":"lbTeS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hDiO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTable = require("./PokemonTable");
var _droppableTable = require("./DroppableTable");
"use client";
function DraggableTable() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, values) {
            return values.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTable, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableTable.DroppableTable), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTable":"9LMud","./DroppableTable":"kUIuJ","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9LMud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultItems", ()=>defaultItems);
///- end collapse -///
parcelHelpers.export(exports, "PokemonTable", ()=>PokemonTable);
var _jsxRuntime = require("react/jsx-runtime");
var _table = require("vanilla-starter/Table");
'use client';
let defaultItems = [
    {
        id: 1,
        name: 'Charizard',
        type: 'Fire, Flying',
        level: 67
    },
    {
        id: 2,
        name: 'Blastoise',
        type: 'Water',
        level: 56
    },
    {
        id: 3,
        name: 'Venusaur',
        type: 'Grass, Poison',
        level: 83
    },
    {
        id: 4,
        name: 'Pikachu',
        type: 'Electric',
        level: 100
    }
];
function PokemonTable(props) {
    let { items = defaultItems, dragAndDropHooks } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
        "aria-label": "Pokemon table",
        selectionMode: "multiple",
        dragAndDropHooks: dragAndDropHooks,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHeader), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                        isRowHeader: true,
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                        children: "Level"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                items: items,
                renderEmptyState: ()=>'Drop items here',
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                children: item.name
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                children: item.type
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                children: item.level
                            })
                        ]
                    })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Table":"ja8ai","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ja8ai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "Row", ()=>Row);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "Cell", ()=>Cell);
parcelHelpers.export(exports, "TableLoadMoreItem", ()=>TableLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _progressCircle = require("./ProgressCircle");
var _lucideReact = require("lucide-react");
var _tableCss = require("./Table.css");
'use client';
function Table(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Table), {
        ...props
    });
}
function Column(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
        ...props,
        className: "react-aria-Column button-base",
        children: ({ allowsSorting, sortDirection })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "column-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
                        role: "presentation",
                        tabIndex: -1,
                        className: "column-name",
                        children: props.children
                    }),
                    allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        className: "sort-indicator",
                        children: sortDirection === 'ascending' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronUp), {
                            size: 16
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            size: 16
                        })
                    }),
                    props.allowsResizing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColumnResizer), {})
                ]
            })
    });
}
function TableHeader({ columns, children, ...otherProps }) {
    let { selectionBehavior, selectionMode, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableHeader), {
        ...otherProps,
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                width: 20,
                minWidth: 20,
                style: {
                    width: 20
                },
                className: "react-aria-Column button-base"
            }),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                width: 32,
                minWidth: 32,
                style: {
                    width: 32
                },
                className: "react-aria-Column button-base",
                children: selectionMode === 'multiple' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
function Row({ id, columns, children, ...otherProps }) {
    let { selectionBehavior, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Row), {
        id: id,
        ...otherProps,
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                    slot: "drag",
                    className: "drag-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.GripVertical), {})
                })
            }),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
function TableBody(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableBody), {
        ...props
    });
}
function Cell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
        ...props
    });
}
function TableLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": "Loading more..."
            })
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Cell","3vnUd"],["Column","3vnUd"],["ColumnResizer","3vnUd"],["Row","3vnUd"],["Table","3vnUd"],["TableBody","3vnUd"],["TableHeader","3vnUd"],["TableLoadMoreItem","3vnUd"],["useTableOptions","3vnUd"],["Collection","2Jd0Q"],["Group","6UspO"]],"./Checkbox":"eZZAR","./ProgressCircle":"c08Ay","lucide-react":[["ChevronDown","kWVt3","default"],["ChevronUp","kvLo9","default"],["GripVertical","1JqDe","default"]],"./Table.css":"cQNEG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kWVt3":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const ChevronDown = (0, _createLucideIconJsDefault.default)("chevron-down", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvLo9":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const ChevronUp = (0, _createLucideIconJsDefault.default)("chevron-up", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cQNEG":[function() {},{}],"kUIuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppableTable", ()=>DroppableTable);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTable = require("./PokemonTable");
'use client';
function DroppableTable() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTable":"9LMud","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8YJMp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
"use client";
function DraggableListBox() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>({
                    'text/plain': item.name
                }));
        },
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableListBox, {});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonListBox":"9ZAis","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k8w2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
"use client";
function DraggableGridList() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>({
                    'text/plain': item.name
                }));
        },
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableGridList, {});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonGridList":"4kzQ7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"67w69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTree = require("./PokemonTree");
"use client";
function DraggableTree() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>({
                    'text/plain': item.name
                }));
        },
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTree, {});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTree":"lbTeS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6FJXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTable = require("./PokemonTable");
"use client";
function DraggableTable() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>({
                    'text/plain': item.name
                }));
        },
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTable, {});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTable":"9LMud","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"75M3F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonListBox = require("./PokemonListBox");
var _draggableListBox = require("./DraggableListBox");
"use client";
function DroppableListBox() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableListBox.DraggableListBox), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableListBox, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonListBox":"9ZAis","./DraggableListBox":"4YVQP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4YVQP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DraggableListBox", ()=>DraggableListBox);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
'use client';
function DraggableListBox() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonListBox":"9ZAis","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dB5zb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonGridList = require("./PokemonGridList");
var _draggableGridList = require("./DraggableGridList");
"use client";
function DroppableGridList() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableGridList.DraggableGridList), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableGridList, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonGridList":"4kzQ7","./DraggableGridList":"2UV6o","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2UV6o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DraggableGridList", ()=>DraggableGridList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
'use client';
function DraggableGridList() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonGridList":"4kzQ7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cHlH5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTree = require("./PokemonTree");
var _draggableTree = require("./DraggableTree");
"use client";
function DroppableTree() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTree.DraggableTree), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTree, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTree":"lbTeS","./DraggableTree":"ccuHo","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ccuHo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DraggableTree", ()=>DraggableTree);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTree = require("./PokemonTree");
"use client";
function DraggableTree() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTree":"lbTeS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bHvIq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTable = require("./PokemonTable");
var _draggableTable = require("./DraggableTable");
"use client";
function DroppableTable() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTable.DraggableTable), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTable, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTable":"9LMud","./DraggableTable":"6zfqG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6zfqG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DraggableTable", ()=>DraggableTable);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTable = require("./PokemonTable");
"use client";
function DraggableTable() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        dragAndDropHooks: dragAndDropHooks
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTable":"9LMud","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hQWFo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
"use client";
function DroppableGridList() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'image/jpeg',
            'image/png'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isFileDropItem)).map(async (item)=>({
                    id: Math.random(),
                    url: URL.createObjectURL(await item.getFile()),
                    name: item.name
                })));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
        "aria-label": "Droppable list",
        items: items,
        dragAndDropHooks: dragAndDropHooks,
        renderEmptyState: ()=>"Drop images here",
        style: {
            height: 250
        },
        "data-size": "small",
        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
                textValue: item.name,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: item.url
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        children: item.name
                    })
                ]
            })
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableGridList, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":[["isFileDropItem","gR4JY"],["Text","jt9fm"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gZy5g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _file = require("@react-spectrum/s2/icons/File");
var _fileDefault = parcelHelpers.interopDefault(_file);
var _folder = require("@react-spectrum/s2/icons/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
"use client";
function DroppableTree() {
    let [files, setFiles] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            (0, _reactAriaComponents.DIRECTORY_DRAG_TYPE)
        ],
        async onRootDrop (e) {
            let getFiles = async (dir)=>{
                let files = [];
                for await (let entry of dir.getEntries())files.push({
                    id: Math.random(),
                    name: entry.name,
                    kind: entry.kind,
                    children: entry.kind === 'directory' ? await getFiles(entry) : []
                });
                return files;
            };
            let dir = e.items.find((0, _reactAriaComponents.isDirectoryDropItem));
            setFiles(await getFiles(dir));
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.Tree), {
        "aria-label": "Droppable tree",
        items: files,
        dragAndDropHooks: dragAndDropHooks,
        renderEmptyState: ()=>'Drop directory here',
        style: {
            height: 250
        },
        children: function renderItem(item) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                flex: '0 0 auto'
                            },
                            children: item.kind === 'directory' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _folderDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                flex: 1,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'hidden'
                            },
                            children: item.name
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                    items: item.children,
                    children: renderItem
                })
            });
        }
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTree, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","react-aria-components":[["Collection","2Jd0Q"],["DIRECTORY_DRAG_TYPE","gR4JY"],["isDirectoryDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","@react-spectrum/s2/icons/File":"99rjs","@react-spectrum/s2/icons/Folder":"dLqBo","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"99rjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.341 5.28 12.72 1.66c-.425-.426-.99-.66-1.59-.66H5.25C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18h9.5c1.24 0 2.25-1.01 2.25-2.25V6.871c0-.592-.24-1.172-.659-1.59m-1.06 1.06c.045.046.073.105.105.16H12.25c-.414 0-.75-.337-.75-.75V2.614c.055.032.113.06.159.106zM14.75 16.5h-9.5c-.414 0-.75-.337-.75-.75V3.25c0-.413.336-.75.75-.75H10v3.25C10 6.99 11.01 8 12.25 8h3.25v7.75c0 .413-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dLqBo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.75 5h-5.964c-.218 0-.424-.095-.567-.259L8.516 2.776C8.088 2.283 7.468 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v10.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-7.5C19 6.01 17.99 5 16.75 5M3.25 3.5h3.565c.218 0 .424.095.567.259L8.458 5H2.5v-.75c0-.413.336-.75.75-.75M17.5 14.75c0 .413-.336.75-.75.75H3.25c-.414 0-.75-.337-.75-.75V6.5h14.25c.414 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ghumf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonListBox = require("./PokemonListBox");
var _draggableListBox = require("./DraggableListBox");
"use client";
function DroppableListBox() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableListBox.DraggableListBox), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableListBox, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonListBox":"9ZAis","./DraggableListBox":"4YVQP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jkus9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonGridList = require("./PokemonGridList");
var _draggableGridList = require("./DraggableGridList");
"use client";
function DroppableGridList() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableGridList.DraggableGridList), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableGridList, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonGridList":"4kzQ7","./DraggableGridList":"2UV6o","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i1oZS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTree = require("./PokemonTree");
var _draggableTree = require("./DraggableTree");
"use client";
function DroppableTree() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTree.DraggableTree), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTree, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTree":"lbTeS","./DraggableTree":"ccuHo","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b7kks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTable = require("./PokemonTable");
var _draggableTable = require("./DraggableTable");
"use client";
function DroppableTable() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTable.DraggableTable), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTable, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTable":"9LMud","./DraggableTable":"6zfqG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aMO71":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
var _draggableListBox = require("./DraggableListBox");
"use client";
function DroppableListBox() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        onItemDrop (e) {
            alert(`Dropped on ${e.target.key}`);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        dragAndDropHooks: dragAndDropHooks,
        items: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableListBox.DraggableListBox), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableListBox, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonListBox":"9ZAis","./DraggableListBox":"4YVQP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bM8fG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
var _draggableGridList = require("./DraggableGridList");
"use client";
function DroppableGridList() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        onItemDrop (e) {
            alert(`Dropped on ${e.target.key}`);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        dragAndDropHooks: dragAndDropHooks,
        items: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableGridList.DraggableGridList), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableGridList, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonGridList":"4kzQ7","./DraggableGridList":"2UV6o","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bu2rI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTree = require("./PokemonTree");
var _draggableTree = require("./DraggableTree");
"use client";
function DroppableTree() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        onItemDrop (e) {
            alert(`Dropped on ${e.target.key}`);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        dragAndDropHooks: dragAndDropHooks,
        items: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTree.DraggableTree), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTree, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTree":"lbTeS","./DraggableTree":"ccuHo","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5gFMP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTable = require("./PokemonTable");
var _draggableTable = require("./DraggableTable");
"use client";
function DroppableTable() {
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        onItemDrop (e) {
            alert(`Dropped on ${e.target.key}`);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        dragAndDropHooks: dragAndDropHooks,
        items: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTable.DraggableTable), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTable, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","./PokemonTable":"9LMud","./DraggableTable":"6zfqG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lrsgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
var _draggableListBox = require("./DraggableListBox");
"use client";
function DroppableListBox() {
    let list = (0, _reactStately.useListData)({
        initialItems: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        async onInsert (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>{
                let pokemon = JSON.parse(await item.getText('pokemon'));
                let processItem = (item)=>({
                        ...item,
                        id: Math.random(),
                        children: item.children?.map(processItem)
                    });
                return processItem(pokemon);
            }));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...items);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...items);
        },
        renderDropIndicator (target) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropIndicator), {
                target: target
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableListBox.DraggableListBox), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableListBox, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":[["DropIndicator","kft18"],["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"./PokemonListBox":"9ZAis","./DraggableListBox":"4YVQP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5lXoQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useListData", ()=>useListData);
parcelHelpers.export(exports, "createListActions", ()=>createListActions);
var _react = require("react");
function useListData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id ?? item.key, filter, initialFilterText = '' } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, _react.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, _react.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...createListActions({
            getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function createListActions(opts, dispatch) {
    let { cursor, getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys
                }));
        },
        addKeysToSelection (selectedKeys) {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return state;
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: 'all'
                };
                return {
                    ...state,
                    selectedKeys: new Set([
                        ...state.selectedKeys,
                        ...selectedKeys
                    ])
                };
            });
        },
        removeKeysFromSelection (selectedKeys) {
            dispatch((state)=>{
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: new Set()
                };
                let selection = state.selectedKeys === 'all' ? new Set(state.items.map(getKey)) : new Set(state.selectedKeys);
                for (let key of selectedKeys)selection.delete(key);
                return {
                    ...state,
                    selectedKeys: selection
                };
            });
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = 'all';
                if (state.selectedKeys !== 'all') {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        newValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bq3z0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
var _draggableGridList = require("./DraggableGridList");
"use client";
function DroppableGridList() {
    let list = (0, _reactStately.useListData)({
        initialItems: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        async onInsert (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>{
                let pokemon = JSON.parse(await item.getText('pokemon'));
                let processItem = (item)=>({
                        ...item,
                        id: Math.random(),
                        children: item.children?.map(processItem)
                    });
                return processItem(pokemon);
            }));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...items);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...items);
        },
        renderDropIndicator (target) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropIndicator), {
                target: target
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableGridList.DraggableGridList), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableGridList, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":[["DropIndicator","kft18"],["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"./PokemonGridList":"4kzQ7","./DraggableGridList":"2UV6o","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"82wpA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTree = require("./PokemonTree");
var _draggableTree = require("./DraggableTree");
"use client";
function DroppableTree() {
    let list = (0, _reactStately.useListData)({
        initialItems: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        async onInsert (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>{
                let pokemon = JSON.parse(await item.getText('pokemon'));
                let processItem = (item)=>({
                        ...item,
                        id: Math.random(),
                        children: item.children?.map(processItem)
                    });
                return processItem(pokemon);
            }));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...items);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...items);
        },
        renderDropIndicator (target) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropIndicator), {
                target: target
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTree.DraggableTree), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTree, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":[["DropIndicator","kft18"],["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"./PokemonTree":"lbTeS","./DraggableTree":"ccuHo","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kqBBk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTable = require("./PokemonTable");
var _draggableTable = require("./DraggableTable");
"use client";
function DroppableTable() {
    let list = (0, _reactStately.useListData)({
        initialItems: [
            {
                id: 1,
                name: 'Beedrill',
                type: 'Bug, Poison',
                level: 25
            },
            {
                id: 2,
                name: 'Pidgeot',
                type: 'Flying',
                level: 40
            },
            {
                id: 3,
                name: 'Fearow',
                type: 'Flying',
                level: 32
            },
            {
                id: 4,
                name: 'Jigglypuff',
                type: 'Fairy',
                level: 56
            }
        ]
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        async onInsert (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>{
                let pokemon = JSON.parse(await item.getText('pokemon'));
                let processItem = (item)=>({
                        ...item,
                        id: Math.random(),
                        children: item.children?.map(processItem)
                    });
                return processItem(pokemon);
            }));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...items);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...items);
        },
        renderDropIndicator (target) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DropIndicator), {
                target: target
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTable.DraggableTable), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTable, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":[["DropIndicator","kft18"],["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"./PokemonTable":"9LMud","./DraggableTable":"6zfqG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cOOTN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
"use client";
function ReorderableListBox() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonListBox.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableListBox, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":"dAd3y","./PokemonListBox":"9ZAis","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"50gJr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
"use client";
function ReorderableGridList() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonGridList.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableGridList, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":"dAd3y","./PokemonGridList":"4kzQ7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cr6HD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTree = require("./PokemonTree");
"use client";
function ReorderableTree() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonTree.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableTree, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":"dAd3y","./PokemonTree":"lbTeS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"70HQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTable = require("./PokemonTable");
"use client";
function ReorderableTable() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonTable.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableTable, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"5lXoQ","react-aria-components":"dAd3y","./PokemonTable":"9LMud","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"OGW8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonListBox = require("./PokemonListBox");
"use client";
function ReorderableListBox() {
    let tree = (0, _reactStately.useTreeData)({
        initialItems: (0, _pokemonListBox.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onMove (e) {
            if (e.target.dropPosition === 'before') tree.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') tree.moveAfter(e.target.key, e.keys);
            else if (e.target.dropPosition === 'on') {
                let targetNode = tree.getItem(e.target.key);
                if (targetNode) {
                    let targetIndex = targetNode.children ? targetNode.children.length : 0;
                    let keyArray = Array.from(e.keys);
                    for(let i = 0; i < keyArray.length; i++)tree.move(keyArray[i], e.target.key, targetIndex + i);
                }
            }
        }
    });
    let processItem = (item)=>{
        return {
            ...item.value,
            children: item.children.map(processItem)
        };
    };
    let items = tree.items.map(processItem);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableListBox, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"lAMwX","react-aria-components":"dAd3y","./PokemonListBox":"9ZAis","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lAMwX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable tree data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useTreeData", ()=>useTreeData);
var _react = require("react");
function useTreeData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id ?? item.key, getChildren = (item)=>item.children } = options;
    // We only want to compute this on initial render.
    let [tree, setItems] = (0, _react.useState)(()=>buildTree(initialItems, new Map()));
    let { items, nodeMap } = tree;
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set(initialSelectedKeys || []));
    function buildTree(initialItems = [], map, parentKey) {
        if (initialItems == null) initialItems = [];
        return {
            items: initialItems.map((item)=>{
                let node = {
                    key: getKey(item),
                    parentKey: parentKey ?? null,
                    value: item,
                    children: null
                };
                node.children = buildTree(getChildren(item), map, node.key).items;
                map.set(node.key, node);
                return node;
            }),
            nodeMap: map
        };
    }
    function updateTree(items, key, update, originalMap) {
        let node = key == null ? null : originalMap.get(key);
        if (node == null) return {
            items,
            nodeMap: originalMap
        };
        let map = new Map(originalMap);
        // Create a new node. If null, then delete the node, otherwise replace.
        let newNode = update(node);
        if (newNode == null) deleteNode(node, map);
        else addNode(newNode, map);
        // Walk up the tree and update each parent to refer to the new children.
        while(node && node.parentKey){
            let nextParent = map.get(node.parentKey);
            let copy = {
                key: nextParent.key,
                parentKey: nextParent.parentKey,
                value: nextParent.value,
                children: null
            };
            let children = nextParent.children;
            if (newNode == null && children) children = children.filter((c)=>c !== node);
            copy.children = children?.map((child)=>{
                if (child === node) // newNode cannot be null here due to the above filter.
                return newNode;
                return child;
            }) ?? null;
            map.set(copy.key, copy);
            newNode = copy;
            node = nextParent;
        }
        if (newNode == null) items = items.filter((c)=>c !== node);
        return {
            items: items.map((item)=>{
                if (item === node) // newNode cannot be null here due to the above filter.
                return newNode;
                return item;
            }),
            nodeMap: map
        };
    }
    function addNode(node, map) {
        map.set(node.key, node);
        if (node.children) for (let child of node.children)addNode(child, map);
    }
    function deleteNode(node, map) {
        map.delete(node.key);
        if (node.children) for (let child of node.children)deleteNode(child, map);
    }
    return {
        items,
        selectedKeys,
        setSelectedKeys,
        getItem (key) {
            return nodeMap.get(key);
        },
        insert (parentKey, index, ...values) {
            setItems(({ items, nodeMap: originalMap })=>{
                let { items: newNodes, nodeMap: newMap } = buildTree(values, originalMap, parentKey);
                // If parentKey is null, insert into the root.
                if (parentKey == null) return {
                    items: [
                        ...items.slice(0, index),
                        ...newNodes,
                        ...items.slice(index)
                    ],
                    nodeMap: newMap
                };
                // Otherwise, update the parent node and its ancestors.
                return updateTree(items, parentKey, (parentNode)=>({
                        key: parentNode.key,
                        parentKey: parentNode.parentKey,
                        value: parentNode.value,
                        children: [
                            ...parentNode.children.slice(0, index),
                            ...newNodes,
                            ...parentNode.children.slice(index)
                        ]
                    }), newMap);
            });
        },
        insertBefore (key, ...values) {
            let node = nodeMap.get(key);
            if (!node) return;
            let parentNode = nodeMap.get(node.parentKey);
            let nodes = parentNode ? parentNode.children : items;
            let index = nodes.indexOf(node);
            this.insert(parentNode?.key ?? null, index, ...values);
        },
        insertAfter (key, ...values) {
            let node = nodeMap.get(key);
            if (!node) return;
            let parentNode = nodeMap.get(node.parentKey);
            let nodes = parentNode ? parentNode.children : items;
            let index = nodes.indexOf(node);
            this.insert(parentNode?.key ?? null, index + 1, ...values);
        },
        prepend (parentKey, ...values) {
            this.insert(parentKey, 0, ...values);
        },
        append (parentKey, ...values) {
            if (parentKey == null) this.insert(null, items.length, ...values);
            else {
                let parentNode = nodeMap.get(parentKey);
                if (!parentNode) return;
                this.insert(parentKey, parentNode.children.length, ...values);
            }
        },
        remove (...keys) {
            if (keys.length === 0) return;
            let newItems = items;
            let prevMap = nodeMap;
            let newTree;
            for (let key of keys){
                newTree = updateTree(newItems, key, ()=>null, prevMap);
                prevMap = newTree.nodeMap;
                newItems = newTree.items;
            }
            setItems(newTree);
            let selection = new Set(selectedKeys);
            for (let key of selectedKeys)if (!newTree.nodeMap.has(key)) selection.delete(key);
            setSelectedKeys(selection);
        },
        removeSelectedItems () {
            this.remove(...selectedKeys);
        },
        move (key, toParentKey, index) {
            setItems(({ items, nodeMap: originalMap })=>{
                let node = originalMap.get(key);
                if (!node) return {
                    items,
                    nodeMap: originalMap
                };
                let { items: newItems, nodeMap: newMap } = updateTree(items, key, ()=>null, originalMap);
                const movedNode = {
                    ...node,
                    parentKey: toParentKey
                };
                // If parentKey is null, insert into the root.
                if (toParentKey == null) {
                    addNode(movedNode, newMap);
                    return {
                        items: [
                            ...newItems.slice(0, index),
                            movedNode,
                            ...newItems.slice(index)
                        ],
                        nodeMap: newMap
                    };
                }
                // Otherwise, update the parent node and its ancestors.
                return updateTree(newItems, toParentKey, (parentNode)=>({
                        key: parentNode.key,
                        parentKey: parentNode.parentKey,
                        value: parentNode.value,
                        children: [
                            ...parentNode.children.slice(0, index),
                            movedNode,
                            ...parentNode.children.slice(index)
                        ]
                    }), newMap);
            });
        },
        moveBefore (key, keys) {
            setItems((prevState)=>{
                let { items, nodeMap } = prevState;
                let node = nodeMap.get(key);
                if (!node) return prevState;
                let toParentKey = node.parentKey ?? null;
                let parent = null;
                if (toParentKey != null) parent = nodeMap.get(toParentKey) ?? null;
                let toIndex = parent?.children ? parent.children.indexOf(node) : items.indexOf(node);
                return moveItems(prevState, keys, parent, toIndex, updateTree, addNode);
            });
        },
        moveAfter (key, keys) {
            setItems((prevState)=>{
                let { items, nodeMap } = prevState;
                let node = nodeMap.get(key);
                if (!node) return prevState;
                let toParentKey = node.parentKey ?? null;
                let parent = null;
                if (toParentKey != null) parent = nodeMap.get(toParentKey) ?? null;
                let toIndex = parent?.children ? parent.children.indexOf(node) : items.indexOf(node);
                toIndex++;
                return moveItems(prevState, keys, parent, toIndex, updateTree, addNode);
            });
        },
        update (oldKey, newValue) {
            setItems(({ items, nodeMap: originalMap })=>updateTree(items, oldKey, (oldNode)=>{
                    let node = {
                        key: oldNode.key,
                        parentKey: oldNode.parentKey,
                        value: newValue,
                        children: null
                    };
                    let tree = buildTree(getChildren(newValue), originalMap, node.key);
                    node.children = tree.items;
                    return node;
                }, originalMap));
        }
    };
}
function moveItems(state, keys, toParent, toIndex, updateTree, addNode) {
    let { items, nodeMap } = state;
    let parent = toParent;
    let removeKeys = new Set(keys);
    while(parent?.parentKey != null){
        if (removeKeys.has(parent.key)) throw new Error('Cannot move an item to be a child of itself.');
        parent = nodeMap.get(parent.parentKey) ?? null;
    }
    let originalToIndex = toIndex;
    let keyArray = Array.isArray(keys) ? keys : [
        ...keys
    ];
    // depth first search to put keys in order
    let inOrderKeys = new Map();
    let removedItems = [];
    let newItems = items;
    let newMap = nodeMap;
    let i = 0;
    function traversal(node, { inorder, postorder }) {
        inorder?.(node);
        if (node != null) for (let child of node.children ?? []){
            traversal(child, {
                inorder,
                postorder
            });
            postorder?.(child);
        }
    }
    function inorder(child) {
        // in-order so we add items as we encounter them in the tree, then we can insert them in expected order later
        if (keyArray.includes(child.key)) inOrderKeys.set(child.key, i++);
    }
    function postorder(child) {
        // remove items and update the tree from the leaves and work upwards toward the root, this way
        // we don't copy child node references from parents inadvertently
        if (keyArray.includes(child.key)) {
            removedItems.push({
                ...newMap.get(child.key),
                parentKey: toParent?.key ?? null
            });
            let { items: nextItems, nodeMap: nextMap } = updateTree(newItems, child.key, ()=>null, newMap);
            newItems = nextItems;
            newMap = nextMap;
        }
        // decrement the index if the child being removed is in the target parent and before the target index
        // the root node is special, it is null, and will not have a key, however, a parentKey can still point to it
        if ((child.parentKey === toParent || child.parentKey === toParent?.key) && keyArray.includes(child.key) && (toParent?.children ? toParent.children.indexOf(child) : items.indexOf(child)) < originalToIndex) toIndex--;
    }
    traversal({
        children: items
    }, {
        inorder,
        postorder
    });
    let inOrderItems = removedItems.sort((a, b)=>inOrderKeys.get(a.key) > inOrderKeys.get(b.key) ? 1 : -1);
    // If parentKey is null, insert into the root.
    if (!toParent || toParent.key == null) {
        inOrderItems.forEach((movedNode)=>{
            addNode(movedNode, newMap);
        });
        return {
            items: [
                ...newItems.slice(0, toIndex),
                ...inOrderItems,
                ...newItems.slice(toIndex)
            ],
            nodeMap: newMap
        };
    }
    // Otherwise, update the parent node and its ancestors.
    return updateTree(newItems, toParent.key, (parentNode)=>({
            key: parentNode.key,
            parentKey: parentNode.parentKey,
            value: parentNode.value,
            children: [
                ...parentNode.children.slice(0, toIndex),
                ...inOrderItems,
                ...parentNode.children.slice(toIndex)
            ]
        }), newMap);
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lxWVn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonGridList = require("./PokemonGridList");
"use client";
function ReorderableGridList() {
    let tree = (0, _reactStately.useTreeData)({
        initialItems: (0, _pokemonGridList.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onMove (e) {
            if (e.target.dropPosition === 'before') tree.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') tree.moveAfter(e.target.key, e.keys);
            else if (e.target.dropPosition === 'on') {
                let targetNode = tree.getItem(e.target.key);
                if (targetNode) {
                    let targetIndex = targetNode.children ? targetNode.children.length : 0;
                    let keyArray = Array.from(e.keys);
                    for(let i = 0; i < keyArray.length; i++)tree.move(keyArray[i], e.target.key, targetIndex + i);
                }
            }
        }
    });
    let processItem = (item)=>{
        return {
            ...item.value,
            children: item.children.map(processItem)
        };
    };
    let items = tree.items.map(processItem);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableGridList, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"lAMwX","react-aria-components":"dAd3y","./PokemonGridList":"4kzQ7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gNaya":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTree = require("./PokemonTree");
"use client";
function ReorderableTree() {
    let tree = (0, _reactStately.useTreeData)({
        initialItems: (0, _pokemonTree.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onMove (e) {
            if (e.target.dropPosition === 'before') tree.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') tree.moveAfter(e.target.key, e.keys);
            else if (e.target.dropPosition === 'on') {
                let targetNode = tree.getItem(e.target.key);
                if (targetNode) {
                    let targetIndex = targetNode.children ? targetNode.children.length : 0;
                    let keyArray = Array.from(e.keys);
                    for(let i = 0; i < keyArray.length; i++)tree.move(keyArray[i], e.target.key, targetIndex + i);
                }
            }
        }
    });
    let processItem = (item)=>{
        return {
            ...item.value,
            children: item.children.map(processItem)
        };
    };
    let items = tree.items.map(processItem);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableTree, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"lAMwX","react-aria-components":"dAd3y","./PokemonTree":"lbTeS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hjHZS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactStately = require("react-stately");
var _reactAriaComponents = require("react-aria-components");
var _pokemonTable = require("./PokemonTable");
"use client";
function ReorderableTable() {
    let tree = (0, _reactStately.useTreeData)({
        initialItems: (0, _pokemonTable.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onMove (e) {
            if (e.target.dropPosition === 'before') tree.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') tree.moveAfter(e.target.key, e.keys);
            else if (e.target.dropPosition === 'on') {
                let targetNode = tree.getItem(e.target.key);
                if (targetNode) {
                    let targetIndex = targetNode.children ? targetNode.children.length : 0;
                    let keyArray = Array.from(e.keys);
                    for(let i = 0; i < keyArray.length; i++)tree.move(keyArray[i], e.target.key, targetIndex + i);
                }
            }
        }
    });
    let processItem = (item)=>{
        return {
            ...item.value,
            children: item.children.map(processItem)
        };
    };
    let items = tree.items.map(processItem);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReorderableTable, {});

},{"react/jsx-runtime":"2Is6Z","react-stately":"lAMwX","react-aria-components":"dAd3y","./PokemonTable":"9LMud","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7zNGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonListBox = require("./PokemonListBox");
"use client";
function DndListBox(props) {
    let list = (0, _reactStately.useListData)({
        initialItems: props.initialItems
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    'pokemon': JSON.stringify(item),
                    'text/plain': item.name
                };
            });
        },
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: ()=>'move',
        async onInsert (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...processedItems);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...processedItems);
        },
        async onRootDrop (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            list.append(...processedItems);
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move' && !e.isInternal) list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndListBox, {
            initialItems: (0, _pokemonListBox.defaultItems),
            "aria-label": "Drag and drop ListBox"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndListBox, {
            initialItems: [],
            "aria-label": "Drag and drop ListBox"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react-stately":"5lXoQ","./PokemonListBox":"9ZAis","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"38skZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonGridList = require("./PokemonGridList");
"use client";
function DndGridList(props) {
    let list = (0, _reactStately.useListData)({
        initialItems: props.initialItems
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    'pokemon': JSON.stringify(item),
                    'text/plain': item.name
                };
            });
        },
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: ()=>'move',
        async onInsert (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...processedItems);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...processedItems);
        },
        async onRootDrop (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            list.append(...processedItems);
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move' && !e.isInternal) list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndGridList, {
            initialItems: (0, _pokemonGridList.defaultItems),
            "aria-label": "Drag and drop GridList"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndGridList, {
            initialItems: [],
            "aria-label": "Drag and drop GridList"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react-stately":"5lXoQ","./PokemonGridList":"4kzQ7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7pZnk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonTree = require("./PokemonTree");
"use client";
function DndTree(props) {
    let list = (0, _reactStately.useListData)({
        initialItems: props.initialItems
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    'pokemon': JSON.stringify(item),
                    'text/plain': item.name
                };
            });
        },
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: ()=>'move',
        async onInsert (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...processedItems);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...processedItems);
        },
        async onRootDrop (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            list.append(...processedItems);
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move' && !e.isInternal) list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndTree, {
            initialItems: (0, _pokemonTree.defaultItems),
            "aria-label": "Drag and drop Tree"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndTree, {
            initialItems: [],
            "aria-label": "Drag and drop Tree"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react-stately":"5lXoQ","./PokemonTree":"lbTeS","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"sSHOY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonTable = require("./PokemonTable");
"use client";
function DndTable(props) {
    let list = (0, _reactStately.useListData)({
        initialItems: props.initialItems
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        renderDragPreview (items) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drag-preview",
                children: [
                    items[0]['text/plain'],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "badge",
                        children: items.length
                    })
                ]
            });
        },
        getItems (keys) {
            return [
                ...keys
            ].map((key)=>{
                let item = list.getItem(key);
                return {
                    'pokemon': JSON.stringify(item),
                    'text/plain': item.name
                };
            });
        },
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: ()=>'move',
        async onInsert (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            if (e.target.dropPosition === 'before') list.insertBefore(e.target.key, ...processedItems);
            else if (e.target.dropPosition === 'after') list.insertAfter(e.target.key, ...processedItems);
        },
        async onRootDrop (e) {
            let processedItems = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            list.append(...processedItems);
        },
        onReorder (e) {
            if (e.target.dropPosition === 'before') list.moveBefore(e.target.key, e.keys);
            else if (e.target.dropPosition === 'after') list.moveAfter(e.target.key, e.keys);
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move' && !e.isInternal) list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndTable, {
            initialItems: (0, _pokemonTable.defaultItems),
            "aria-label": "Drag and drop Table"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DndTable, {
            initialItems: [],
            "aria-label": "Drag and drop Table"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react-stately":"5lXoQ","./PokemonTable":"9LMud","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aDo0k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonListBox = require("./PokemonListBox");
var _draggableListBox = require("./DraggableListBox");
"use client";
function DroppableListBox() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: (target, types, allowedOperations)=>'copy',
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableListBox.DraggableListBox), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableListBox, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonListBox":"9ZAis","./DraggableListBox":"4YVQP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hXzR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonGridList = require("./PokemonGridList");
var _draggableGridList = require("./DraggableGridList");
"use client";
function DroppableGridList() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: (target, types, allowedOperations)=>'copy',
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableGridList.DraggableGridList), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableGridList, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonGridList":"4kzQ7","./DraggableGridList":"2UV6o","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5gshN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTree = require("./PokemonTree");
var _draggableTree = require("./DraggableTree");
"use client";
function DroppableTree() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: (target, types, allowedOperations)=>'copy',
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTree.DraggableTree), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTree, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTree":"lbTeS","./DraggableTree":"ccuHo","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5BuCH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _pokemonTable = require("./PokemonTable");
var _draggableTable = require("./DraggableTable");
"use client";
function DroppableTable() {
    let [items, setItems] = (0, _react.useState)([]);
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        acceptedDragTypes: [
            'pokemon'
        ],
        getDropOperation: (target, types, allowedOperations)=>'copy',
        async onRootDrop (e) {
            let items = await Promise.all(e.items.filter((0, _reactAriaComponents.isTextDropItem)).map(async (item)=>JSON.parse(await item.getText('pokemon'))));
            setItems(items);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _draggableTable.DraggableTable), {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableTable, {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["isTextDropItem","gR4JY"],["useDragAndDrop","dAd3y"]],"react":"a1TxN","./PokemonTable":"9LMud","./DraggableTable":"6zfqG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dWIdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonListBox = require("./PokemonListBox");
var _droppableListBox = require("./DroppableListBox");
"use client";
function DraggableListBox() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonListBox.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        getAllowedDropOperations: ()=>[
                'copy'
            ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableListBox, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableListBox.DroppableListBox), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonListBox":"9ZAis","./DroppableListBox":"4Ffgp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9CgoT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonGridList = require("./PokemonGridList");
var _droppableGridList = require("./DroppableGridList");
"use client";
function DraggableGridList() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonGridList.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        getAllowedDropOperations: ()=>[
                'copy'
            ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableGridList, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableGridList.DroppableGridList), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonGridList":"4kzQ7","./DroppableGridList":"82HX7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gH3uL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonTree = require("./PokemonTree");
var _droppableTree = require("./DroppableTree");
"use client";
function DraggableTree() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonTree.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        getAllowedDropOperations: ()=>[
                'copy'
            ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTree, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableTree.DroppableTree), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonTree":"lbTeS","./DroppableTree":"1ABDu","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lE1vQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonTable = require("./PokemonTable");
var _droppableTable = require("./DroppableTable");
"use client";
function DraggableTable() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonTable.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        getAllowedDropOperations: ()=>[
                'copy'
            ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTable, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableTable.DroppableTable), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonTable":"9LMud","./DroppableTable":"kUIuJ","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6WqTr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonListBox = require("./PokemonListBox");
var _droppableListBox = require("./DroppableListBox");
"use client";
function DraggableListBox() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonListBox.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move') list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonListBox.PokemonListBox), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableListBox, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableListBox.DroppableListBox), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonListBox":"9ZAis","./DroppableListBox":"4Ffgp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2jN2z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonGridList = require("./PokemonGridList");
var _droppableGridList = require("./DroppableGridList");
"use client";
function DraggableGridList() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonGridList.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move') list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonGridList.PokemonGridList), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableGridList, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableGridList.DroppableGridList), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonGridList":"4kzQ7","./DroppableGridList":"82HX7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bGAFM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonTree = require("./PokemonTree");
var _droppableTree = require("./DroppableTree");
"use client";
function DraggableTree() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonTree.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move') list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTree.PokemonTree), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTree, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableTree.DroppableTree), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonTree":"lbTeS","./DroppableTree":"1ABDu","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k2P84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _reactStately = require("react-stately");
var _pokemonTable = require("./PokemonTable");
var _droppableTable = require("./DroppableTable");
"use client";
function DraggableTable() {
    let list = (0, _reactStately.useListData)({
        initialItems: (0, _pokemonTable.defaultItems)
    });
    let { dragAndDropHooks } = (0, _reactAriaComponents.useDragAndDrop)({
        getItems (keys, items) {
            return items.map((item)=>{
                return {
                    'text/plain': `${item.name} \u{2013} ${item.type}`,
                    'text/html': `<strong>${item.name}</strong> \u{2013} <em>${item.type}</em>`,
                    'pokemon': JSON.stringify(item)
                };
            });
        },
        onDragEnd (e) {
            if (e.dropOperation === 'move') list.remove(...e.keys);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pokemonTable.PokemonTable), {
        items: list.items,
        dragAndDropHooks: dragAndDropHooks
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    style: {
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'
    },
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableTable, {}),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _droppableTable.DroppableTable), {})
    ]
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"dAd3y","react-stately":"5lXoQ","./PokemonTable":"9LMud","./DroppableTable":"kUIuJ","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cSREm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PPGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, layoutDelegate, onAction, disallowTypeAhead, linkBehavior = 'action', keyboardNavigationBehavior = 'arrow', escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate,
        layoutDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior,
        disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior,
        keyboardNavigationBehavior,
        shouldSelectOnPressUp
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: 'grid',
        id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"./utils":"aJkqW","@react-aria/grid":[["useGridSelectionAnnouncement","deyzk"],["useHighlightSelectionDescription","eO4Xt"]],"@react-aria/focus":"eSQu0","@react-aria/selection":"ldksp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJkqW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"deyzk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelectionAnnouncement", ()=>useGridSelectionAnnouncement);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _react = require("react");
var _i18N = require("@react-aria/i18n");
var _utils = require("@react-aria/utils");
function useGridSelectionAnnouncement(props, state) {
    let { getRowText = (key)=>state.collection.getTextValue?.(key) ?? state.collection.getItem(key)?.textValue } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, _react.useRef)(selection);
    let announceSelectionChange = (0, _react.useCallback)(()=>{
        if (!state.selectionManager.isFocused || selection === lastSelection.current) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = diffSelection(selection, lastSelection.current);
        let removedKeys = diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            let firstKey = state.selectionManager.selectedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let currentSelectionText = getRowText(firstKey);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let firstKey = addedKeys.keys().next().value;
            if (firstKey != null) {
                let addedText = getRowText(firstKey);
                if (addedText) messages.push(stringFormatter.format('selectedItem', {
                    item: addedText
                }));
            }
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            let firstKey = removedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let removedText = getRowText(firstKey);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || lastSelection.current?.size > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, _liveAnnouncer.announce)(messages.join(' '));
        lastSelection.current = selection;
    }, [
        selection,
        state.selectionManager.selectedKeys,
        state.selectionManager.isFocused,
        state.selectionManager.selectionBehavior,
        state.selectionManager.selectionMode,
        state.collection,
        getRowText,
        stringFormatter
    ]);
    // useUpdateEffect will handle using useEffectEvent, no need to stabilize anything on this end
    (0, _utils.useUpdateEffect)(()=>{
        if (state.selectionManager.isFocused) announceSelectionChange();
        else {
            // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
            let raf = requestAnimationFrame(announceSelectionChange);
            return ()=>cancelAnimationFrame(raf);
        }
    }, [
        selection,
        state.selectionManager.isFocused
    ]);
}
function diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

},{"@react-aria/live-announcer":"3nbSW","../intl/*.json":"hdtsN","react":"a1TxN","@react-aria/i18n":"7lxyl","@react-aria/utils":"ekc37","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hdtsN":[function(require,module,exports,__globalThis) {
const _temp0 = require("549f76802fea3145");
const _temp1 = require("99e711b09beafbae");
const _temp2 = require("d822d49a9f50f8f2");
const _temp3 = require("62716c14c7ab3b19");
const _temp4 = require("f993c3bd895f4a55");
const _temp5 = require("87ba517e0d2284cb");
const _temp6 = require("9959e6866268baa2");
const _temp7 = require("a5d29cf49321ccbd");
const _temp8 = require("d4a263166a379f7");
const _temp9 = require("adb7cef23c3e7915");
const _temp10 = require("b85e649d4f0c8fa0");
const _temp11 = require("669dff92f11c15b2");
const _temp12 = require("56a3bfdc95a3af99");
const _temp13 = require("92bd2be1c2e45a26");
const _temp14 = require("ac7b779e60091ebf");
const _temp15 = require("7350c7eb30e615e3");
const _temp16 = require("3260bfccae03c79c");
const _temp17 = require("e01abdb08e203859");
const _temp18 = require("5551bd334b751799");
const _temp19 = require("a555cf93e0917ba2");
const _temp20 = require("f519d273a2594a58");
const _temp21 = require("2ab2dc559350f8cb");
const _temp22 = require("aa7f9e578044416a");
const _temp23 = require("7828f13f1de12a9c");
const _temp24 = require("b776cb1c3588783c");
const _temp25 = require("b2c037c8f99b4b1d");
const _temp26 = require("3656d7d096e21208");
const _temp27 = require("64de068ffd5db517");
const _temp28 = require("6afb03c6be24a7db");
const _temp29 = require("fac4d0e10b154d11");
const _temp30 = require("5207f24182fa30c9");
const _temp31 = require("6c177c75c6c9f015");
const _temp32 = require("1c95bec940ff1fe8");
const _temp33 = require("736ec483e330f374");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"549f76802fea3145":"ctpKo","99e711b09beafbae":"ctpKo","d822d49a9f50f8f2":"ctpKo","62716c14c7ab3b19":"ctpKo","f993c3bd895f4a55":"ctpKo","87ba517e0d2284cb":"ctpKo","9959e6866268baa2":"3Tpgz","a5d29cf49321ccbd":"ctpKo","d4a263166a379f7":"ctpKo","adb7cef23c3e7915":"ctpKo","b85e649d4f0c8fa0":"ctpKo","669dff92f11c15b2":"ctpKo","56a3bfdc95a3af99":"ctpKo","92bd2be1c2e45a26":"ctpKo","ac7b779e60091ebf":"ctpKo","7350c7eb30e615e3":"ctpKo","3260bfccae03c79c":"ctpKo","e01abdb08e203859":"ctpKo","5551bd334b751799":"ctpKo","a555cf93e0917ba2":"ctpKo","f519d273a2594a58":"ctpKo","2ab2dc559350f8cb":"ctpKo","aa7f9e578044416a":"ctpKo","7828f13f1de12a9c":"ctpKo","b776cb1c3588783c":"ctpKo","b2c037c8f99b4b1d":"ctpKo","3656d7d096e21208":"ctpKo","64de068ffd5db517":"ctpKo","6afb03c6be24a7db":"ctpKo","fac4d0e10b154d11":"ctpKo","5207f24182fa30c9":"ctpKo","6c177c75c6c9f015":"ctpKo","1c95bec940ff1fe8":"ctpKo","736ec483e330f374":"ctpKo"}],"3Tpgz":[function(require,module,exports,__globalThis) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

},{}],"eO4Xt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes the description for a grid selectable collection.
 * @param props
 */ parcelHelpers.export(exports, "useHighlightSelectionDescription", ()=>useHighlightSelectionDescription);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useHighlightSelectionDescription(props) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    let modality = (0, _interactions.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, _react.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, _utils.useDescription)(interactionDescription);
    return descriptionProps;
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"h4qnk","@react-aria/interactions":"dkfxW","@react-aria/i18n":"7lxyl","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNHH4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior, keyboardNavigationBehavior, shouldSelectOnPressUp } = (0, _utils1.listMap).get(state);
    let descriptionId = (0, _utils.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current?.contains(document.activeElement))) (0, _focus.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        if (node.level > 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = state.collection.getChildren?.(parent.key);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': node?.index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, _utils.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, _utils.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, _utils.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture,
        onKeyDown,
        onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && node.textValue ? `${(0, _utils1.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils1.getRowId)(state, node.key)
    });
    if (isVirtualized) {
        let { collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, _utils.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/utils":[["chain","ij7eS"],["getScrollParent","1Tu7U"],["mergeProps","aNvcY"],["scrollIntoViewport","1lzpw"],["useSlotId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"@react-aria/focus":[["focusSafely","2ysUy"],["getFocusableTreeWalker","9oPIl"]],"./utils":"aJkqW","react":"a1TxN","@react-aria/interactions":"dkfxW","@react-aria/selection":"cJdJS","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hH0ym":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid list.
 * @param props - Props for the selection checkbox.
 * @param state - State of the list, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>useGridListSelectionCheckbox);
var _grid = require("@react-aria/grid");
var _utils = require("./utils");
function useGridListSelectionCheckbox(props, state) {
    let { key } = props;
    const { checkboxProps } = (0, _grid.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, _utils.getRowId)(state, key)}`
        }
    };
}

},{"@react-aria/grid":"8WxyV","./utils":"aJkqW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PgS5":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragPreview", ()=>DragPreview);
var _reactDom = require("react-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const DragPreview = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function DragPreview(props, ref) {
    let render = props.children;
    let [children, setChildren] = (0, _react.useState)(null);
    let domRef = (0, _react.useRef)(null);
    let raf = (0, _react.useRef)(undefined);
    (0, _react.useImperativeHandle)(ref, ()=>(items, callback)=>{
            // This will be called during the onDragStart event by useDrag. We need to render the
            // preview synchronously before this event returns so we can call event.dataTransfer.setDragImage.
            let result = render(items);
            let element;
            let offsetX;
            let offsetY;
            if (result && typeof result === 'object' && 'element' in result) {
                element = result.element;
                offsetX = result.x;
                offsetY = result.y;
            } else element = result;
            (0, _reactDom.flushSync)(()=>{
                setChildren(element);
            });
            // Yield back to useDrag to set the drag image.
            callback(domRef.current, offsetX, offsetY);
            // Remove the preview from the DOM after a frame so the browser has time to paint.
            raf.current = requestAnimationFrame(()=>{
                setChildren(null);
            });
        }, [
        render
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);
    if (!children) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            zIndex: -100,
            position: 'absolute',
            top: 0,
            left: -100000
        },
        ref: domRef
    }, children);
});

},{"react-dom":"gC2PC","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6Pwfq":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles drag interactions for an element, with support for traditional mouse and touch
 * based drag and drop, in addition to full parity for keyboard and screen reader users.
 */ parcelHelpers.export(exports, "useDrag", ()=>useDrag);
var _react = require("react");
var _dragManager = require("./DragManager");
var _constants = require("./constants");
var _utils = require("./utils");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
const MESSAGES = {
    keyboard: {
        start: 'dragDescriptionKeyboard',
        end: 'endDragKeyboard'
    },
    touch: {
        start: 'dragDescriptionTouch',
        end: 'endDragTouch'
    },
    virtual: {
        start: 'dragDescriptionVirtual',
        end: 'endDragVirtual'
    }
};
function useDrag(options) {
    let { hasDragButton, isDisabled } = options;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/dnd');
    let state = (0, _react.useRef)({
        options,
        x: 0,
        y: 0
    }).current;
    state.options = options;
    let isDraggingRef = (0, _react.useRef)(null);
    let [isDragging, setDraggingState] = (0, _react.useState)(false);
    let setDragging = (element)=>{
        isDraggingRef.current = element;
        setDraggingState(!!element);
    };
    let { addGlobalListener, removeAllGlobalListeners } = (0, _utils1.useGlobalListeners)();
    let modalityOnPointerDown = (0, _react.useRef)(null);
    let onDragStart = (e)=>{
        if (e.defaultPrevented) return;
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        // If this drag was initiated by a mobile screen reader (e.g. VoiceOver or TalkBack), enter virtual dragging mode.
        if (modalityOnPointerDown.current === 'virtual') {
            e.preventDefault();
            startDragging(e.target);
            modalityOnPointerDown.current = null;
            return;
        }
        if (typeof options.onDragStart === 'function') options.onDragStart({
            type: 'dragstart',
            x: e.clientX,
            y: e.clientY
        });
        let items = options.getItems();
        // Clear existing data (e.g. selected text on the page would be included in some browsers)
        e.dataTransfer.clearData?.();
        (0, _utils.writeToDataTransfer)(e.dataTransfer, items);
        let allowed = (0, _constants.DROP_OPERATION).all;
        if (typeof options.getAllowedDropOperations === 'function') {
            let allowedOperations = options.getAllowedDropOperations();
            allowed = (0, _constants.DROP_OPERATION).none;
            for (let operation of allowedOperations)allowed |= (0, _constants.DROP_OPERATION)[operation] || (0, _constants.DROP_OPERATION).none;
        }
        (0, _utils.setGlobalAllowedDropOperations)(allowed);
        let effectAllowed = (0, _constants.EFFECT_ALLOWED)[allowed] || 'none';
        e.dataTransfer.effectAllowed = effectAllowed === 'cancel' ? 'none' : effectAllowed;
        // If there is a preview option, use it to render a custom preview image that will
        // appear under the pointer while dragging. If not, the element itself is dragged by the browser.
        if (typeof options.preview?.current === 'function') options.preview.current(items, (node, userX, userY)=>{
            if (!node) return;
            // Compute the offset that the preview will appear under the mouse.
            // If possible, this is based on the point the user clicked on the target.
            // If the preview is much smaller, then just use the center point of the preview.
            let size = node.getBoundingClientRect();
            let rect = e.currentTarget.getBoundingClientRect();
            let defaultX = e.clientX - rect.x;
            let defaultY = e.clientY - rect.y;
            if (defaultX > size.width || defaultY > size.height) {
                defaultX = size.width / 2;
                defaultY = size.height / 2;
            }
            // Start with default offsets.
            let offsetX = defaultX;
            let offsetY = defaultY;
            // If the preview renderer supplied explicit offsets, use those.
            if (typeof userX === 'number' && typeof userY === 'number') {
                offsetX = userX;
                offsetY = userY;
            }
            // Clamp the offset so it stays within the preview bounds. Browsers
            // automatically clamp out-of-range values, but doing it ourselves
            // prevents the visible "snap" that can occur when the browser adjusts
            // them after the first drag update.
            offsetX = Math.max(0, Math.min(offsetX, size.width));
            offsetY = Math.max(0, Math.min(offsetY, size.height));
            // Rounding height to an even number prevents blurry preview seen on some screens
            let height = 2 * Math.round(size.height / 2);
            node.style.height = `${height}px`;
            e.dataTransfer.setDragImage(node, offsetX, offsetY);
        });
        // Enforce that drops are handled by useDrop.
        addGlobalListener(window, 'drop', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            console.warn('Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.');
        }, {
            once: true
        });
        state.x = e.clientX;
        state.y = e.clientY;
        // Wait a frame before we set dragging to true so that the browser has time to
        // render the preview image before we update the element that has been dragged.
        let target = e.target;
        requestAnimationFrame(()=>{
            setDragging(target);
        });
    };
    let onDrag = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (e.clientX === state.x && e.clientY === state.y) return;
        if (typeof options.onDragMove === 'function') options.onDragMove({
            type: 'dragmove',
            x: e.clientX,
            y: e.clientY
        });
        state.x = e.clientX;
        state.y = e.clientY;
    };
    let onDragEnd = (e)=>{
        // Prevent the drag event from propagating to any parent draggables
        e.stopPropagation();
        if (typeof options.onDragEnd === 'function') {
            let event = {
                type: 'dragend',
                x: e.clientX,
                y: e.clientY,
                dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[e.dataTransfer.dropEffect]
            };
            // Chrome Android always returns none as its dropEffect so we use the drop effect set in useDrop via
            // onDragEnter/onDragOver instead. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
            if (0, _utils.globalDropEffect) event.dropOperation = (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[0, _utils.globalDropEffect];
            options.onDragEnd(event);
        }
        setDragging(null);
        removeAllGlobalListeners();
        (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
        (0, _utils.setGlobalDropEffect)(undefined);
    };
    // If the dragged element is removed from the DOM via onDrop, onDragEnd won't fire: https://bugzilla.mozilla.org/show_bug.cgi?id=460801
    // In this case, we need to manually call onDragEnd on cleanup
    (0, _react.useEffect)(()=>{
        return ()=>{
            // Check that the dragged element has actually unmounted from the DOM and not a React Strict Mode false positive.
            // https://github.com/facebook/react/issues/29585
            // React 16 ran effect cleanups before removing elements from the DOM but did not have this issue.
            if (isDraggingRef.current && (!isDraggingRef.current.isConnected || parseInt((0, _react.version), 10) < 17)) {
                if (typeof state.options.onDragEnd === 'function') {
                    let event = {
                        type: 'dragend',
                        x: 0,
                        y: 0,
                        dropOperation: (0, _constants.DROP_EFFECT_TO_DROP_OPERATION)[(0, _utils.globalDropEffect) || 'none']
                    };
                    state.options.onDragEnd(event);
                }
                setDragging(null);
                (0, _utils.setGlobalAllowedDropOperations)((0, _constants.DROP_OPERATION).none);
                (0, _utils.setGlobalDropEffect)(undefined);
            }
        };
    }, [
        state
    ]);
    let onPress = (e)=>{
        if (e.pointerType !== 'keyboard' && e.pointerType !== 'virtual') return;
        startDragging(e.target);
    };
    let startDragging = (target)=>{
        if (typeof state.options.onDragStart === 'function') {
            let rect = target.getBoundingClientRect();
            state.options.onDragStart({
                type: 'dragstart',
                x: rect.x + rect.width / 2,
                y: rect.y + rect.height / 2
            });
        }
        _dragManager.beginDragging({
            element: target,
            items: state.options.getItems(),
            allowedDropOperations: typeof state.options.getAllowedDropOperations === 'function' ? state.options.getAllowedDropOperations() : [
                'move',
                'copy',
                'link'
            ],
            onDragEnd (e) {
                setDragging(null);
                if (typeof state.options.onDragEnd === 'function') state.options.onDragEnd(e);
            }
        }, stringFormatter);
        setDragging(target);
    };
    let modality = (0, _utils.useDragModality)();
    let message = !isDragging ? MESSAGES[modality].start : MESSAGES[modality].end;
    let descriptionProps = (0, _utils1.useDescription)(stringFormatter.format(message));
    let interactions = {};
    if (!hasDragButton) // If there's no separate button to trigger accessible drag and drop mode,
    // then add event handlers to the draggable element itself to start dragging.
    // For keyboard, we use the Enter key in a capturing listener to prevent other
    // events such as selection from also occurring. We attempt to infer whether a
    // pointer event (e.g. long press) came from a touch screen reader, and then initiate
    // dragging in the native onDragStart listener above.
    interactions = {
        ...descriptionProps,
        onPointerDown (e) {
            modalityOnPointerDown.current = (0, _utils1.isVirtualPointerEvent)(e.nativeEvent) ? 'virtual' : e.pointerType;
            // Try to detect virtual drag passthrough gestures.
            if (e.width < 1 && e.height < 1) // iOS VoiceOver.
            modalityOnPointerDown.current = 'virtual';
            else {
                let rect = e.currentTarget.getBoundingClientRect();
                let offsetX = e.clientX - rect.x;
                let offsetY = e.clientY - rect.y;
                let centerX = rect.width / 2;
                let centerY = rect.height / 2;
                if (Math.abs(offsetX - centerX) <= 0.5 && Math.abs(offsetY - centerY) <= 0.5) // Android TalkBack.
                modalityOnPointerDown.current = 'virtual';
                else modalityOnPointerDown.current = e.pointerType;
            }
        },
        onKeyDownCapture (e) {
            if (e.target === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        onKeyUpCapture (e) {
            if (e.target === e.currentTarget && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                startDragging(e.target);
            }
        },
        onClick (e) {
            // Handle NVDA/JAWS in browse mode, and touch screen readers. In this case, no keyboard events are fired.
            if ((0, _utils1.isVirtualClick)(e.nativeEvent) || modalityOnPointerDown.current === 'virtual') {
                e.preventDefault();
                e.stopPropagation();
                startDragging(e.target);
            }
        }
    };
    if (isDisabled) return {
        dragProps: {
            draggable: 'false'
        },
        dragButtonProps: {},
        isDragging: false
    };
    return {
        dragProps: {
            ...interactions,
            draggable: 'true',
            onDragStart,
            onDrag,
            onDragEnd
        },
        dragButtonProps: {
            ...descriptionProps,
            onPress
        },
        isDragging
    };
}

},{"react":"a1TxN","./DragManager":"43gWL","./constants":"dL7d2","./utils":"gR4JY","../intl/*.json":"8XG9M","@react-aria/utils":[["isVirtualClick","81Nqj"],["isVirtualPointerEvent","81Nqj"],["useDescription","h4qnk"],["useGlobalListeners","ceyTG"]],"@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=dnd.afee4965.js.map
